module.exports = __webpack_public_path__ + "Open_Sans-normal-600.49fbe77658d29a343cd0.woff";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/Open_Sans-normal-600.woff
// module id = 902
// module chunks = 2